import { sortString, sortNumber, toSearchableString } from 'app/utils';
import { generateMonth } from 'app/components/pages/professional-availability/tables/table-visits/Utils';

const TEMPLATE_NAME = 'VISITS_INITIAL_ASSESSMENT';

const sort = function (a, b) {
    let result = sortNumber(a.status, b.status);
    if (result !== 0) {
        return result;
    }
    const aName = a.name || null;
    const bName = b.name || null;
    result = sortString(aName, bName);
    if (result !== 0) {
        return result;
    }
    return sortString(a.key, b.key);
};

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterDataSearch = (data, term) => 
{
    const resultData = {};
    
    const result = data.professionals.filter(item => {
        const Name = item.name ? filterByTerm(item.name, term) : false;
        return filterByTerm(item.name, term) || Name;
    });

    if(sort) 
    {
        result.sort(sort);
    }
    
    resultData.monthProfessionals = generateMonth(data.resume) ? generateMonth(data.resume) : [];
    resultData.professionals = result.length > 0 ? result : data.professionals;
    resultData.resume = data.resume ? data.resume : [];

    return resultData;
};

const filterData = data => 
{
    const professionals = [];
    const result = {};

    if(data && data.professionalAvailability) 
    {
        for(let key in data.professionalAvailability)
        {
            professionals.push(data.professionalAvailability[key]);
        }

        result.resume = data.resume;
    }
    
    result.professionals = professionals;
    result.professionals.sort((a, b) => a.name.localeCompare(b.name));
    
    return result;
};

const initialState = () => ({
    loading: false,
    data: {
        professionals: [],
        monthProfessionals: {},
        resume: {},
    },
    visit: {},
    filter: {
        term: '',
        data: {
            professionals: [],
            monthProfessionals: {},
            resume: {},
        },
    },
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;
            
            return {
                ...state,
                loading: false,
                data: filterDataSearch(filterData(data), null),
                filter: {
                    ...state.filter,
                    data: filterDataSearch(filterData(data), null),
                },
            };
        }
        case `${TEMPLATE_NAME}_SEARCH`: {
            const term = action.payload;

            return {
                ...state,
                filter: {
                    ...state.filter,
                    term,
                    data: filterDataSearch(state.data, term),
                },
            };
        }
        
        case `${TEMPLATE_NAME}_DETAIL`: {
            const data = action.payload;
            console.log("DATEIL", data);
            return {
                ...state,
                visit: data
            };
        }

        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};
export default reducer;
